export { ProfileModule } from './ProfileModule'
export const profilePath = '/et/company/:companyId/profile'
